// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"_3d63d168","description":"_151cbd33","button":"_384b6305"};